import { getCargaTarjeta } from '../../../../../services/declaracionRenta/empresarioIndividualService';
import { TARJETAS_PERSONA } from './tarjetasPersona';

/**
 * Cargador de la parte persona del AT 2026: lee las tarjetas del panel que alimentan el
 * F22 y deja en data.persona sus filas, solo si la carga está validada, y el estado de cada
 * una (para mostrarlo y para bloquear el cálculo con cargas por revisar). Común a todos los
 * regímenes del AT 2026: cada módulo lo agrega a sus dataLoaders.
 */
export { TARJETAS_PERSONA };

const ANIO_TRIBUTARIO = 2026;

export const cargadorPersona = {
  key: 'persona',
  loader: async (idCompany) => {
    const respuestas = await Promise.all(TARJETAS_PERSONA.map((t) => (
      getCargaTarjeta(idCompany, ANIO_TRIBUTARIO, t.id).catch(() => null)
    )));
    return TARJETAS_PERSONA.reduce((cargas, t, i) => ({ ...cargas, [t.id]: respuestas[i]?.data || null }), {});
  },
  apply: (formData, cargas) => {
    const persona = { estados: {} };
    TARJETAS_PERSONA.forEach((t) => {
      const carga = cargas[t.id];
      persona.estados[t.id] = carga?.estado || null;
      persona[t.id] = carga?.estado === 'validada' ? carga.filas : [];
    });
    return { ...formData, persona };
  },
};
